import React from 'react';

const EmbarcacaoContext = React.createContext();

export default EmbarcacaoContext;
